import { useEffect, useRef, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { makeid } from "../../../utils/random";
import { useTranslation } from 'react-i18next'
import ReactDOM from "react-dom";
import Icon from "components/Icon";
interface Children{
  name?: string,
  link?: string
}

interface Item{
  icon?: any,
  name?: string,
  selected?: boolean,
  children?: Children[],
  key?: number,
  link?: string,
  path?: string,
  verify: Function | null,
  scroll_event_handler: Function | null
}

export default function MenuItem(item: Item){
  const { t } = useTranslation()
  const [ ID ] = useState(`menu-item-${makeid(7)}-${makeid(5)}`);
  const ref = useRef<null|HTMLLIElement>(null);
  const history = useHistory();

  useEffect(()=>{
    const div = document.createElement("div");
    let time:NodeJS.Timeout;
    function addMore(){
      if(ref && ref.current){
        clearTimeout(time)
        time = setTimeout(()=>{
          div.style.display = "block";
        },500);
        
        const rect = ref.current.getBoundingClientRect();
        div.style.top = rect.top+(rect.height/2) + "px";
      }
    }
    function removeMore(){
      clearTimeout(time)
      time = setTimeout(()=>{
        div.style.display = "";
      },100);
    }
    if(ref && ref.current){
      const current = ref.current;
      div.classList.add("menu-item-more-absolute");
      const rect = current.getBoundingClientRect();
      div.style.top = rect.top+(rect.height/2) + "px";

      const menu_list = document.getElementById("masterpage-menu-list-area");
      if(menu_list){
        menu_list.appendChild(div)
      }

      ReactDOM.render(
      <>
        <div className="menu-item-more-name">{t('menu:'+item.name)}</div>
        {item.children?(<>
          <div className="menu-item-more-list">
            {item.children.map((c,k)=>{
              return <div className="menu-item-more-link" key={k}><div onClick={()=>{
                let currentTarget = document.getElementById(ID);
                if(currentTarget){
                  let parent = currentTarget.parentElement;
                  if(parent){
                    let elements = parent.getElementsByClassName("menu-item-selected");
                    for (let i = 0; i < elements.length; i++) {
                      const element = elements[i];
                      element.classList.remove("menu-item-selected");
                    }
                  }
                  currentTarget.classList.add("menu-item-selected");

                  if(window.innerWidth < 1100){
                    let masterpage = document.getElementById("masterpage");
                    if(masterpage && masterpage.classList.contains("menu-open")){
                      masterpage.classList.remove("menu-open");
                    }
                  }

                  history.push(`${item.path}${c.link}`);
                }
              }} className="menu-item-more-list-item">{t('menu:'+c.name)}</div></div>
            })}
          </div>
        </>):<></>}
      </>
      ,div);
      
      current.addEventListener("mouseenter",addMore);
      current.addEventListener("mouseleave",removeMore);
      if(item.children){
        div.addEventListener("mouseenter",addMore);
        div.addEventListener("mouseleave",removeMore);
      }

      return ()=>{
        if(current){
          current.removeEventListener("mouseenter",addMore);
          current.removeEventListener("mouseleave",removeMore);

          if(menu_list){
            menu_list.removeChild(div)
          }
        }
      }
    }    
  },[ref, item, ID, history, t]);

  function renderMenuItem(){
    return <>
      <div className="menu-item-area">
        <div className="menu-item-icon">{item.icon}</div>
        <div className="menu-item-name">{t('menu:'+item.name)}</div>
      </div>
      <div className="menu-item-more">
        <div className="menu-item-more-name">{t('menu:'+item.name)}</div>
        {item.children?(<>
          <div className="menu-item-more-list">
            {item.children.map((c,k)=>{
              return <Link to={`${item.path}${c.link}`} key={k}><div onClick={()=>{
                let currentTarget = document.getElementById(ID);
                if(currentTarget){
                  let parent = currentTarget.parentElement;
                  if(parent){
                    let elements = parent.getElementsByClassName("menu-item-selected");
                    for (let i = 0; i < elements.length; i++) {
                      const element = elements[i];
                      element.classList.remove("menu-item-selected");
                    }
                  }
                  currentTarget.classList.add("menu-item-selected");

                  if(window.innerWidth < 1100){
                    let masterpage = document.getElementById("masterpage");
                    if(masterpage && masterpage.classList.contains("menu-open")){
                      masterpage.classList.remove("menu-open");
                    }
                  }
                }
              }} className="menu-item-more-list-item">{t('menu:'+c.name)}</div></Link>
            })}
          </div>
        </>):<></>}
      </div>
      {item.children?(
        <div className="menu-item-more-icon">
          <Icon name="angle-right"/>
        </div>
      ):""}
    </>;
  }

  return <li 
    ref={ref}
    id={ID}
    className={"menu-item"+(item.selected?" menu-item-selected":"")} 
    onClick={({currentTarget})=>{
      if(!item.children){
        let parent = currentTarget.parentElement;
        if(parent){
          let elements = parent.getElementsByClassName("menu-item-selected");
          for (let i = 0; i < elements.length; i++) {
            const element = elements[i];
            element.classList.remove("menu-item-selected");
          } 
          elements = parent.getElementsByClassName("open-menu-item");
          for (let i = 0; i < elements.length; i++) {
            const element = elements[i];
            element.classList.remove("open-menu-item");
          } 
        }
        currentTarget.classList.add("menu-item-selected");
        if(window.innerWidth < 1100){
          let masterpage = document.getElementById("masterpage");
          if(masterpage && masterpage.classList.contains("menu-open")){
            masterpage.classList.remove("menu-open");
          }
        }
      } else {
        let masterpage = document.getElementById("masterpage");
        if(masterpage && masterpage.classList.contains("menu-open")){
          if(currentTarget.classList.contains("open-menu-item")){
            currentTarget.classList.remove("open-menu-item");
          } else {
            let parent = currentTarget.parentElement;
            if(parent){
              let elements = parent.getElementsByClassName("open-menu-item");
              for (let i = 0; i < elements.length; i++) {
                const element = elements[i];
                element.classList.remove("open-menu-item");
              } 
            }
            currentTarget.classList.add("open-menu-item");
          }
        }
        if(item.verify) {
          setTimeout(()=>{
            const rect = currentTarget.getBoundingClientRect();
            if(item.scroll_event_handler)item.scroll_event_handler(rect.height);
          },100);
          setTimeout(item.verify,150);
        }
      }
    }}
  >
  {!item.children?<Link to={`${item.link}`}>{renderMenuItem()}</Link>:renderMenuItem()}
  </li>;
}